enum blockNames {
    FeatureItem = 'feature-item',
    Features = 'features',
    HeroUnit = 'hero-unit',
    Separator = 'separator',
    Testimonial = 'testimonial',
    TextImage = 'text-image',
    TextLogoItem = 'text-logo-item',
    TextLogos = 'text-logos',
    NewsletterSubscribe = 'newsletter-subscribe',
    Contacts = 'contacts',
    ContactItem = 'contact-item',
    Map = 'map',
    LogoGrid = 'logo-grid',
    LogoGridItem = 'logo-grid-item',
    Team = 'team',
    TeamItem = 'team-item',
    ImageBackground = 'image-background',
    Badge = 'badge',
    Button = 'button',
    BulletListItem = 'bullet-list-item',
    TextImageLogo = 'text-image-logo',
    Customers = 'customers',
    Customer = 'customer',
    Faqs = 'faqs',
    Faq = 'faq',
    CallToAction = 'call-to-action',
    FeatureCallout = 'big-feature',
    Documents = 'documents',
    Document = 'document',
    ImageCarousel = 'image-carousel',
    SingleImage = 'single-image',
    HorizontalRule = 'horizontal-rule',
    Spacer = 'spacer',
  }
  
  export default blockNames